export default {
    MultiTenant: {
        DefaultAccessKey: "00000000-0000-0000-0000-000000000000",
        requestTypesBlacklist: [
            "GetHistoryRequest",
        ],
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/multi-tenant.ts